export enum StorageName {
    AccessToken = "accessToken",
    ShipmentListFilterParams = "shipmentListFilterParams",
    ShipmentListPageSize = "shipmentListPageSize",
    ShipmentListSortStore = "shipmentListSort",
    AppLanguage = "appLanguage",
    AppTimeZone = "appTimeZone",
    ShipmentListPaginationStorePreviousPage = "shipmentListPaginationStorePreviousPage",
    ShipmentListPaginationStoreSearchAfter = "shipmentListPaginationStoreSearchAfter"
}
